import React, { useRef } from 'react';
import {
  Card,
  CardHeader,
  CardPreview,
  CardFooter,
  Text,
  Link,
  makeStyles,
} from '@fluentui/react-components';
import type { NewsItem } from '@/types';
import { CommentTree } from './CommentTree';
import { HeaderRef } from './Header';


const useStyles = makeStyles({
   card: {
    width: '100%',
     height: '100%', // ✅ fills the grid cell height
    gap: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
  headlineCard: {
    width: '100%',
    gap: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
 preview: {
  display: 'flex',
  gap: '8px',
},

iframe: {
  flex: 1,
  aspectRatio: '16 / 9',
  width: '100%',
  border: 0,
  borderRadius: '6px',
},

image: {
  flex: 1,
  aspectRatio: '16 / 9',   // ⭐ THIS is what you were missing
  width: '100%',
  objectFit: 'cover',
  borderRadius: '6px',
},
titleRow: {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',   // space between title and button
  flexWrap: 'wrap', // allows wrap on small screens
},

titleText: {
  fontSize: '16px',
},

headlineTitle: {
  fontSize: '42px',
  fontWeight: '700',
},
watchButton: {
  fontSize: '13px',
  whiteSpace: 'nowrap',
},
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    flex: 1, // ✅ make description grow to fill remaining space
  },
  links: {
    display: 'flex',
    gap: '12px',
  },
  comments: {
    marginTop: '8px',
    borderTop: '1px solid #eee',
    paddingTop: '8px',
  },
});

// ✅ Add routineKey & dateKey to props
interface NewsCardProps {
  item: NewsItem;
  routineKey?: string;
  dateKey?: string;
     onLoginClick: () => void;
}

export const NewsCard: React.FC<NewsCardProps> = ({ item, routineKey, dateKey ,onLoginClick}) => {
  const styles = useStyles();

  const watchUrl = item.videoFilePath
    ? `https://www.youtube.com/watch?v=${item.videoFilePath}`
    : null;

  const embedUrl = item.videoFilePath
    ? `https://www.youtube.com/embed/${item.videoFilePath}`
    : null;

  return (
   <Card appearance="outline" className={styles.card}>
    {item.IsHeadline && (
    <div style={{ padding: '12px 0' }}>
      <div className={styles.titleRow}>
        <Text
          style={{
            fontSize: '42px',
            fontWeight: 900,
            lineHeight: 1.2,
            margin: 0,
          }}
        >
          {item.title}
        </Text>
      </div>
      {item.source && (
        <Text style={{ color: '#888', marginTop: '4px' }}>{item.source}</Text>
      )}
      {watchUrl && (
        <Link
          href={watchUrl}
          target="_blank"
          rel="noreferrer"
          className={styles.watchButton}
          style={{ marginTop: '4px' }}
        >
          ▶ Watch
        </Link>
      )}
    </div>
  ) }
  {/* Media */}
  {(item.imageUrl || embedUrl) && (
    <CardPreview>
      {item.imageUrl && !item.imageUrl.includes('files.s3') ? (
        <img src={item.imageUrl} alt="news" className={styles.image} />
      ) : (
        embedUrl && (
          <iframe
            src={embedUrl}
            title="YouTube video"
            className={styles.iframe}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        )
      )}
    </CardPreview>
  )}

  {/* Headline */}
   {!item.IsHeadline && (
    <CardHeader
      header={
        <div className={styles.titleRow}>
          <Text weight="semibold" className={styles.titleText}>
            {item.title}
          </Text>
          {watchUrl && (
            <Link
              href={watchUrl}
              target="_blank"
              rel="noreferrer"
              className={styles.watchButton}
            >
              ▶ Watch
            </Link>
          )}
        </div>
      }
      description={item.source}
    />
  )}

  {/* Description */}
  <div className={styles.body}>
    {item.description && <Text>{item.description}</Text>}
    <div className={styles.links}>
      {watchUrl && (
        <Link href={watchUrl} target="_blank" rel="noreferrer">
          Watch on YouTube
        </Link>
      )}
      {item.url && (
        <Link href={item.url} target="_blank" rel="noreferrer">
          Read more
        </Link>
      )}
    </div>
  </div>

  {/* Comments */}
  <CardFooter className={styles.comments}>
    <CommentTree
      newsId={item.id}
      routineKey={routineKey}
      dateKey={dateKey}
      onLoginClick={onLoginClick}
    />
  </CardFooter>
</Card>
  );
};
